<template>
    <div class="uploadTipDiv">
        <div class="uploadTip">
            <div class="tipTitle">
                请上传本人证件照
            </div>
            <div class="tips">
                请您上传近期正面、免冠、清晰的电子证件照，作为您的校友卡头像
            </div>
            <div style="margin: 10px 0;display: flex;justify-content: center;">
                <img class="bigImg" src="../IdentitAuthentication/images/btn_shangchuan_nor@3x.png" @click="loadImg"
                    v-if="fileData.file == ''">
                <img class="bigImg" :src="fileData.file" v-else>
            </div>
            <div class="case">
                <div class="caseTitle">(示例照片)</div>
                <div class="casePhotoDiv">
                    <img src="../../assets/image/casePhoto.jpeg" alt="" class="casePhoto">
                </div>
            </div>

            <div style="text-align: center;">
                <el-button style="margin:auto;" class="lwork" type="primary" @click="commit">上传证件照</el-button>
            </div>

            <!-- 弹窗 -->
            <van-action-sheet v-model="drawer" cancel-text="取消" close-on-click-action @cancel="drawer = false">
                <van-uploader :before-read="beforeRead" :after-read="afterRead">
                    <div class="selectPhoto">从相册选择</div>
                </van-uploader>
            </van-action-sheet>
        </div>
    </div>
</template>
<script>
import { dataURLtoFile } from '../../assets/js/dataURLtoFile'
export default {
    data() {
        return {
            drawer: false,
            fileData: {
                file: "",
            },
            fileUplode: '',
        }
    },
    created() {

    },
    methods: {
        async commit() {
            if (this.fileData.file === '') {
                this.$toast("请上传证件照")
            } else {
                let param = new window.FormData();
                param.append("file", this.fileUplode.file)
                param.append("user_id", window.localStorage.getItem("user_id"));
                const result = await this.$http.post("/upload/upload_all_img", param);
                if (result.data.success == true) {
                    this.$toast("上传成功");
                    this.$router.push('/uploadSucc')
                } else {
                    this.$toast("上传失败");
                }
            }
        },
        loadImg(index) {
            this.drawer = true;
        },
        beforeRead(file) {
            if (file.type !== "image/jpeg" && file.type !== "image/png") {
                this.$toast("请上传 jpg,png 格式图片");
                return false;
            }
            if (file.size < 55182) {
                this.$toast("图片必须大于600*800像素");
                return false;
            }
            this.drawer = false;
            return true;
        },
        async afterRead(file) {
            if (file.file.size > 110000) {
                let fileName = file.file.name;
                // 创建Canvas对象(画布)
                let canvas = document.createElement('canvas')
                // 获取对应的CanvasRenderingContext2D对象(画笔)
                let context = canvas.getContext('2d')
                // 创建新的图片对象
                let img = new Image()
                // 指定图片的DataURL(图片的base64编码数据)
                img.src = file.content
                // 监听浏览器加载图片完成，然后进行绘制
                img.onload = () => {
                    // 指定canvas画布大小，该大小为最后生成图片的大小
                    canvas.width = 600
                    canvas.height = 800
                    /* drawImage画布绘制的方法。(0,0)表示以Canvas画布左上角为起点，600，800是将图片按给定的像素进行缩小。*/
                    /* 如果不指定缩小的像素，图片将以图片原始大小进行绘制，图片像素如果大于画布将会从左上角开始按画布大小部分绘制图片，最后得到的图片就是张局部图。图片小于画布就会有黑边。*/
                    context.drawImage(img, 0, 0, 600, 800)
                    // 将绘制完成的图片重新转化为base64编码，file.file.type为图片类型，0.92为默认压缩质量
                    file.content = canvas.toDataURL(file.file.type, 0.92)
                    file.file = dataURLtoFile(file.content, fileName);
                    console.log(file)
                    this.fileData.file = file.content
                    this.fileUplode = file
                }
            } else {
                this.fileData.file = file.content
                this.fileUplode = file
            }
        },
        gotoUpload() {
            this.$router.push('/uploadUserPhoto')
        }
    }
}
</script>
<style scoped lang="less">
.uploadTip {
    width: 90%;
    margin-left: 5%;

    .tipTitle {
        margin: 10px 0;
        font-size: 1.5rem;
        font-weight: 400;
        color: #333333;
    }

    .tips {
        font-size: 1.2rem;
        font-weight: 400;
        color: #333333;
    }
}

.caseTitle {
    text-align: center;
    font-size: 1.3rem;
    font-weight: 400;
    color: #333333;
}

.casePhotoDiv {
    margin: 20px auto;
    width: 50vw;
    height: 70vw;

    .casePhoto {
        width: 100%;
        height: 100%;
    }
}

.lwork {
    background-color: #00706E;
    text-align: center;
    width: 80% !important;
    border-radius: 35px;
    display: block;
    height: 40px;
    font-size: 20px;
    color: #fff;
    margin: 0 auto;
    padding: 0;
}

// 上传图片
.bigImg {
    width: 50vw;
    height: 70vw;
}

.el-upload--picture-card {
    height: 0px;
    width: 0px;
}

// icon
.van-uploader__upload-icon {
    font-size: 52px;
}

.van-uploader__preview-image {
    height: 186px;
    width: 300px;
}

.preview-cover .van-ellipsis {}

.van-uploader__upload {
    height: 186px;
    width: 300px;
    margin: 8px auto;
    border: dashed 2px #333333;
    // border-style: dotted;
}

.preview-cover {
    position: absolute;
    bottom: 0;
    box-sizing: border-box;
    // width: 100%;
    width: 300px;
    height: 186px;
    padding: 4px;
    color: #fff;
    font-size: 12px;
    text-align: center;
    background: rgba(0, 0, 0, 0.3);
}

// 弹出层
.el-drawer__header {
    margin: 4px;
    padding: 0%;
}

.el-drawer__open .el-drawer.btt {
    border-radius: 30px 30px 0 0;
}

// .com-item{
//     text-align: center;
//     width: 100%;
//     padding: 15px;
//     color: #333333;
//     font-size: 20px;
// }
.el-button--primary {
    color: #fff;
    background-color: #409eff;
    border-color: #409eff;
    margin: auto;
}

.el-button+.el-button {
    margin: auto;
}

.selectPhoto {
    font-size: 1.2rem;
    font-weight: 400;
    color: #00706E;
    margin: 20px 0;
}

.van-uploader {
    position: relative;
    left: 50%;
    transform: translateX(-50%);
}
</style>



// WEBPACK FOOTER //
// src/components/uploadUserPhoto/uploadUserPhoto.vue